import LoginForm from "../Components/LoginForm";

const Contact = () => {
  return (
    <>
      <h1>Login</h1>
      <LoginForm />
    </>
  );
};

export default Contact;
